import React, { useEffect, useRef, useState } from "react";

import KpiCard from "../../../CommonComponents/Dashboard/KpiCard/KpiCard";
import { KPI_CARD_BACKGROUND } from "../../../../utils/Constants";

import "./stylesEventKpi.css";
import DashboardLineChart from "../../../CommonComponents/Dashboard/DashboardLineChart/DashboardLineChart";
import GeographicUserInsights from "../../../CommonComponents/Dashboard/GeographicUserInsights/GeographicUserInsights";
import BetTypes from "./BetTypes/BetTypes";
import MarketTypes from "./MarketTypes/MarketTypes";
import BettingActivity from "./BettingActivity/BettingActivity";
import BetStatuses from "./BetStatuses/BetStatuses";
import { Switch, Table } from "antd";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import { useSearchParams } from "react-router-dom";

const formatCurrency = (value) => {
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};

const formatWithPlus = (num) => {
  if (num == null || isNaN(num)) return "-";

  const hasDecimal = num % 1 !== 0;

  const formatted = Intl.NumberFormat("en-US", {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(num);

  return num > 0 ? `+${formatted}` : formatted;
};

const initialStates = [
  {
    name: "California",
    abbr: "CA",
    amount: 0,
  },
  {
    name: "Washington",
    abbr: "WA",
    amount: 0,
  },
  {
    name: "Texas",
    abbr: "TX",
    amount: 0,
  },
  {
    name: "Georgia",
    abbr: "GA",
    amount: 0,
  },
  {
    name: "Florida",
    abbr: "FL",
    amount: 0,
  },
  {
    name: "Minnesota",
    abbr: "MN",
    amount: 0,
  },
  {
    name: "Illinois",
    abbr: "IL",
    amount: 0,
  },
  {
    name: "Mississippi",
    abbr: "MS",
    amount: 0,
  },
  {
    name: "Alabama",
    abbr: "AL",
    amount: 0,
  },
  {
    name: "South Carolina",
    abbr: "SC",
    amount: 0,
  },
  {
    name: "Wisconsin",
    abbr: "WI",
    amount: 0,
  },
  {
    name: "Missouri",
    abbr: "MO",
    amount: 0,
  },
  {
    name: "North Carolina",
    abbr: "NC",
    amount: 0,
  },
  {
    name: "Pennsylvania",
    abbr: "PA",
    amount: 0,
  },
  {
    name: "Virginia",
    abbr: "VA",
    amount: 0,
  },
  {
    name: "Oregon",
    abbr: "OR",
    amount: 0,
  },
  {
    name: "Massachusetts",
    abbr: "MA",
    amount: 0,
  },
  {
    name: "Ohio",
    abbr: "OH",
    amount: 0,
  },
  {
    name: "Utah",
    abbr: "UT",
    amount: 0,
  },
  {
    name: "Oklahoma",
    abbr: "OK",
    amount: 0,
  },
  {
    name: "Tennessee",
    abbr: "TN",
    amount: 0,
  },
  {
    name: "Indiana",
    abbr: "IN",
    amount: 0,
  },
  {
    name: "Colorado",
    abbr: "CO",
    amount: 0,
  },
  {
    name: "Hawaii",
    abbr: "HI",
    amount: 0,
  },
  {
    name: "Kentucky",
    abbr: "KY",
    amount: 0,
  },
  {
    name: "Arkansas",
    abbr: "AR",
    amount: 0,
  },
  {
    name: "Kansas",
    abbr: "KS",
    amount: 0,
  },
  {
    name: "Iowa",
    abbr: "IA",
    amount: 0,
  },
  {
    name: "Nebraska",
    abbr: "NE",
    amount: 0,
  },
  {
    name: "New Mexico",
    abbr: "NM",
    amount: 0,
  },
  {
    name: "South Dakota",
    abbr: "SD",
    amount: 0,
  },
  {
    name: "New Hampshire",
    abbr: "NH",
    amount: 0,
  },
  {
    name: "North Dakota",
    abbr: "ND",
    amount: 0,
  },
  {
    name: "Rhode Island",
    abbr: "RI",
    amount: 0,
  },
  {
    name: "West Virginia",
    abbr: "WV",
    amount: 0,
  },
  {
    name: "Delaware",
    abbr: "DE",
    amount: 0,
  },
  {
    name: "Maine",
    abbr: "ME",
    amount: 0,
  },
  {
    name: "Alaska",
    abbr: "AK",
    amount: 0,
  },
  {
    name: "Washington, D.C.",
    abbr: "DC",
    amount: 0,
  },
  {
    name: "Wyoming",
    abbr: "WY",
    amount: 0,
  },
  {
    name: "Vermont",
    abbr: "VT",
    amount: 0,
  },
  {
    name: "Connecticut",
    abbr: "CT",
    amount: 0,
  },
  {
    name: "New York",
    abbr: "NY",
    amount: 0,
  },
]

function EventKpi() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    false
  );

  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");

  const [isApiRunning, setIsApiRunning] = useState(false);

  const containerRef = useRef(null);

  const [fixedHeader, setFixedHeader] = useState(true);

  const [eventKpis, setEventKpis] = useState({
    profitAndLoss: 0,
    margin: 0,
    cashOutProfitAndLoss: 0,
    turnover: 0,
    playersEngaged: 0,
    repeatBettors: 0,
    avgBetAmount: 0,
  });

  const [eventKpiLineChartData, setEventKpiLineChartData] = useState({
    labels: [],

    datasets: [
      {
        label: "Total bets",
        data: [],
        backgroundColor: ["#EE72BC"],
        borderColor: ["#EE72BC"],
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
    headers: [
      { title: "Total bets", amount: 0 },
      { title: "Straight", amount: 0 },
      { title: "Parlay", amount: 0 },
    ],
  });

  const [usersByStateData, setUsersByStateData] = useState(initialStates);

  const [bettingData, setBettingData] = useState([
    {
      name: "Accepted Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Rejected Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Cancelled Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "% of Winning Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "% Live",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Unsettled Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
  ]);

  const [profitabilityData, setProfitabilityData] = useState([
    {
      name: "Total Stake",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Unsettled Stakes",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Net P/L",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Margin",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Earning per Bet",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Average Stake",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
  ]);

  const [oddsData, setOddsData] = useState([
    {
      name: "Highest Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Lowest Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Avg Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
  ]);

  const [winningsOddsData, setWinningsOddsData] = useState([
    {
      name: "Highest Winn. Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Lowest Winn. Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
    {
      name: "Avg Highest Winn. Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
    },
  ]);

  const bettingColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Total Bets",
      dataIndex: "totalBets",
      key: "totalBets",
      width: 200,
    },
    {
      title: "Straight Bets",
      dataIndex: "straightBets",
      key: "straightBets",
      width: 200,
    },
    {
      title: "Parlay Bets",
      dataIndex: "parlayBets",
      key: "parlayBets",
      width: 200,
    },
  ];
  const profitabilityColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Total Bets",
      dataIndex: "totalBets",
      key: "totalBets",
      width: 200,
    },
    {
      title: "Straight Bets",
      dataIndex: "straightBets",
      key: "straightBets",
      width: 200,
    },
    {
      title: "Parlay Bets",
      dataIndex: "parlayBets",
      key: "parlayBets",
      width: 200,
    },
  ];
  const oddsColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Total Bets",
      dataIndex: "totalBets",
      key: "totalBets",
      width: 200,
    },
    {
      title: "Straight Bets",
      dataIndex: "straightBets",
      key: "straightBets",
      width: 200,
    },
    {
      title: "Parlay Bets",
      dataIndex: "parlayBets",
      key: "parlayBets",
      width: 200,
    },
  ];
  const winningsOddsColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Total Bets",
      dataIndex: "totalBets",
      key: "totalBets",
      width: 200,
    },
    {
      title: "Straight Bets",
      dataIndex: "straightBets",
      key: "straightBets",
      width: 200,
    },
    {
      title: "Parlay Bets",
      dataIndex: "parlayBets",
      key: "parlayBets",
      width: 200,
    },
  ];

  const getEvenDetailsKpiData = async () => {
    setIsApiRunning(true);
    try {
      const requests = [
        PrivateAdminPanelInstance.post(API_ROUTES.GET_EVENT_DETAILS_KPI_TABLE, {
          event_id: eventId,
        }),
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_DAILY_HISTOGRAM,
          {
            event_id: eventId,
          }
        ),
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_OVERVIEW,
          {
            event_id: eventId,
          }
        ),
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_USER_STATE_MAP,
          {
            event_id: eventId,
          }
        ),
      ];

      const responses = await Promise.allSettled(requests);
      const [
        kpiTableResponse,
        kpiDailyHistogramResponse,
        kpiOverviewResponse,
        kpiUserStateMapResponse,
      ] = responses;

      if (kpiTableResponse.status === "fulfilled") {
        const data = kpiTableResponse?.value?.data?.data || [];

        const bettingData = [
          {
            name: "Accepted Bets",
            totalBets: `${data.total.betting.accepted.value} (${data.total.betting.accepted.percentage}%)`,
            straightBets: `${data.straight.betting.accepted.value} (${data.straight.betting.accepted.percentage}%)`,
            parlayBets: `${data.parlay.betting.accepted.value} (${data.parlay.betting.accepted.percentage}%)`,
          },
          {
            name: "Rejected Bets",
            totalBets: `${data.total.betting.rejected.value} (${data.total.betting.rejected.percentage}%)`,
            straightBets: `${data.straight.betting.rejected.value} (${data.straight.betting.rejected.percentage}%)`,
            parlayBets: `${data.parlay.betting.rejected.value} (${data.parlay.betting.rejected.percentage}%)`,
          },
          {
            name: "Cancelled Bets",
            totalBets:
              data.total.betting.cancelled.value +
              " (" +
              data.total.betting.cancelled.percentage +
              "%)",
            straightBets:
              data.straight.betting.cancelled.value +
              " (" +
              data.straight.betting.cancelled.percentage +
              "%)",
            parlayBets:
              data.parlay.betting.cancelled.value +
              " (" +
              data.parlay.betting.cancelled.percentage +
              "%)",
          },
          {
            name: "% of Winning Bets",
            totalBets:
              data.total.betting.winning.value +
              " (" +
              data.total.betting.winning.percentage +
              "%)",
            straightBets:
              data.straight.betting.winning.value +
              " (" +
              data.straight.betting.winning.percentage +
              "%)",
            parlayBets:
              data.parlay.betting.winning.value +
              " (" +
              data.parlay.betting.winning.percentage +
              "%)",
          },
          {
            name: "% Live",
            totalBets:
              data.total.betting.live.value +
              " (" +
              data.total.betting.live.percentage +
              "%)",
            straightBets:
              data.straight.betting.live.value +
              " (" +
              data.straight.betting.live.percentage +
              "%)",
            parlayBets:
              data.parlay.betting.live.value +
              " (" +
              data.parlay.betting.live.percentage +
              "%)",
          },
          {
            name: "Unsettled Bets",
            totalBets:
              data.total.betting.unsettled.value +
              " (" +
              data.total.betting.unsettled.percentage +
              "%)",
            straightBets:
              data.straight.betting.unsettled.value +
              " (" +
              data.straight.betting.unsettled.percentage +
              "%)",
            parlayBets:
              data.parlay.betting.unsettled.value +
              " (" +
              data.parlay.betting.unsettled.percentage +
              "%)",
          },
        ];

        const profitabilityData = [
          {
            name: "Total Stake",
            totalBets: formatCurrency(data.total.profitability.total_stake),
            straightBets: formatCurrency(
              data.straight.profitability.total_stake
            ),
            parlayBets: formatCurrency(data.parlay.profitability.total_stake),
          },
          {
            name: "Unsettled Stakes",
            totalBets: formatCurrency(data.total.profitability.unsettled_stake),
            straightBets: formatCurrency(
              data.straight.profitability.unsettled_stake
            ),
            parlayBets: formatCurrency(
              data.parlay.profitability.unsettled_stake
            ),
          },
          {
            name: "Net P/L",
            totalBets: formatCurrency(data.total.profitability.net_profit_loss),
            straightBets: formatCurrency(
              data.straight.profitability.net_profit_loss
            ),
            parlayBets: formatCurrency(
              data.parlay.profitability.net_profit_loss
            ),
          },
          {
            name: "Margin",
            totalBets: data.total.profitability.margin + "%",
            straightBets: data.straight.profitability.margin + "%",
            parlayBets: data.parlay.profitability.margin + "%",
          },
          {
            name: "Earning per Bet",
            totalBets: formatCurrency(
              data.total.profitability.earnings_per_bet
            ),
            straightBets: formatCurrency(
              data.straight.profitability.earnings_per_bet
            ),
            parlayBets: formatCurrency(
              data.parlay.profitability.earnings_per_bet
            ),
          },
          {
            name: "Average Stake",
            totalBets: formatCurrency(data.total.profitability.average_stake),
            straightBets: formatCurrency(
              data.straight.profitability.average_stake
            ),
            parlayBets: formatCurrency(data.parlay.profitability.average_stake),
          },
        ];
        const oddsData = [
          {
            name: "Highest Odds",
            totalBets: formatWithPlus(data.total.odds.all.highest),
            straightBets: formatWithPlus(data.straight.odds.all.highest),
            parlayBets: formatWithPlus(data.parlay.odds.all.highest),
          },
          {
            name: "Lowest Odds",
            totalBets: formatWithPlus(data.total.odds.all.lowest),
            straightBets: formatWithPlus(data.straight.odds.all.lowest),
            parlayBets: formatWithPlus(data.parlay.odds.all.lowest),
          },
          {
            name: "Avg Odds",
            totalBets: formatWithPlus(data.total.odds.all.average),
            straightBets: formatWithPlus(data.straight.odds.all.average),
            parlayBets: formatWithPlus(data.parlay.odds.all.average),
          },
        ];
        const winningsOddsData = [
          {
            name: "Highest Winn. Odds",
            totalBets: formatWithPlus(data.total.odds.winning.highest),
            straightBets: formatWithPlus(data.straight.odds.winning.highest),
            parlayBets: formatWithPlus(data.parlay.odds.winning.highest),
          },
          {
            name: "Lowest Winn. Odds",
            totalBets: formatWithPlus(data.total.odds.winning.lowest),
            straightBets: formatWithPlus(data.straight.odds.winning.lowest),
            parlayBets: formatWithPlus(data.parlay.odds.winning.lowest),
          },
          {
            name: "Avg Highest Winn. Odds",
            totalBets: formatWithPlus(data.total.odds.winning.average),
            straightBets: formatWithPlus(data.straight.odds.winning.average),
            parlayBets: formatWithPlus(data.parlay.odds.winning.average),
          },
        ];
        setBettingData(bettingData);
        setProfitabilityData(profitabilityData);
        setOddsData(oddsData);
        setWinningsOddsData(winningsOddsData);
      }

      if (kpiDailyHistogramResponse.status === "fulfilled") {
        const dailyHistogramData =
          kpiDailyHistogramResponse?.value?.data?.data?.data || [];

        const headers = dailyHistogramData.header;
        const graph = dailyHistogramData.graph;

        setEventKpiLineChartData({
          labels: Object.keys(graph.total),
          datasets: [
            {
              label: "Total Bets",
              data: Object.values(graph.total),
              backgroundColor: ["#EE72BC"],
              borderColor: ["#EE72BC"],
              borderWidth: 1,
              borderRadius: 1,
            },
          ],
          headers: [
            { title: "Total Bets", amount: headers.total.value },
            { title: "Straight", amount: headers.straight.value },
            { title: "Parlay", amount: headers.parlay.value },
          ],
        });
      }

      if (kpiOverviewResponse.status === "fulfilled") {
        const data = kpiOverviewResponse?.value?.data?.data || {};

        setEventKpis({
          profitAndLoss: data.profit_loss,
          margin: data.margin,
          cashOutProfitAndLoss: data.cashout_pl,
          turnover: data.turnover,
          playersEngaged: data.players_engaged.value,
          repeatBettors: data.repeat_bettors.value,
          avgBetAmount: data.average_bet_amount.value,
        });
      }

      if (kpiUserStateMapResponse.status === "fulfilled") {
        const data = kpiUserStateMapResponse?.value?.data?.data?.data || [];
      
        const states = [
          ...initialStates.map(stateItem => {
            const match = data.find(item => item.state === stateItem.name);
            return {
              ...stateItem,
              amount: match ? match.count : stateItem.amount
            };
          }),
      
          ...data
            .filter(item => !initialStates.some(s => s.name === item.state))
            .map(item => ({
              name: item.state,
              abbr: item.state,
              amount: item.count
            }))
        ];
      
        setUsersByStateData(states);
      }
    } catch (error) {
      console.log("Error getting event details kpi data:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getEvenDetailsKpiData();
  }, []);

  return (
    <div className="event-kpi-container">
      <div className="event-kpi-top">
        <KpiCard
          isApiRunning={isApiRunning}
          title={"Profit & Loss"}
          value={eventKpis.profitAndLoss}
          hugeValue={false}
          rate={false}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title={"Margin"}
          value={eventKpis.margin}
          hugeValue={false}
          rate={true}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title={"Cash Out Profit and Loss"}
          value={eventKpis.cashOutProfitAndLoss}
          customColor={false}
          hugeValue={false}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title="Turnover"
          value={eventKpis.turnover}
          hugeValue={true}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.TRASNPARENT}
        />
      </div>
      <div className="event-kpi-middle">
        <div className="event-kpi-middle-left">
          <DashboardLineChart
            data={eventKpiLineChartData}
            showCustomDatePicker={false}
            headers={eventKpiLineChartData.headers}
            isApiRunning={isApiRunning}
            setSelected={() => {}}
            customOptions={[]}
            rightInfo={false}
          />
        </div>
        <div className="event-kpi-middle-right">
          <GeographicUserInsights
            data={usersByStateData}
            isApiRunning={isApiRunning}
            title={"Users by State"}
          />
        </div>
      </div>
      <div className="event-kpi-bottom">
        <KpiCard
          isApiRunning={isApiRunning}
          title="Players Engaged"
          value={eventKpis.playersEngaged}
          maximumFractionDigits={0}
          hugeValue={false}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title={"REPEAT BETTORS"}
          value={eventKpis.repeatBettors}
          maximumFractionDigits={0}
          minimumFractionDigits={0}
          hugeValue={false}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title={"Avg Bet Amount"}
          value={eventKpis.avgBetAmount}
          hugeValue={false}
          percentage={false}
          isMoney={true}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
      </div>
      <div className="event-kpi-table-container" ref={containerRef}>
        <div className="event-kpi-table-container-item">
          <h3>Betting </h3>
          {fixedHeader && (
            <div className="custom-fixed-header">
              <Table
                columns={bettingColumns}
                pagination={false}
                showHeader={true}
                locale={{ emptyText: <span style={{ display: "none" }} /> }}
              />
            </div>
          )}
          <Table
            columns={bettingColumns}
            dataSource={bettingData}
            pagination={false}
            scroll={{ x: 1000 }}
            showHeader={false}
          />
        </div>
        <div className="event-kpi-table-container-item">
          <h3>Profitability</h3>
          {fixedHeader && (
            <div className="custom-fixed-header">
              <Table
                columns={profitabilityColumns}
                pagination={false}
                showHeader={true}
                locale={{ emptyText: <span style={{ display: "none" }} /> }}
              />
            </div>
          )}
          <Table
            columns={profitabilityColumns}
            dataSource={profitabilityData}
            pagination={false}
            scroll={{ x: 1000 }}
            showHeader={false}
          />
        </div>
        <div className="event-kpi-table-container-item">
          <h3>Odds</h3>
          {fixedHeader && (
            <div className="custom-fixed-header">
              <Table
                columns={oddsColumns}
                pagination={false}
                showHeader={true}
                locale={{ emptyText: <span style={{ display: "none" }} /> }}
              />
            </div>
          )}
          <Table
            columns={oddsColumns}
            dataSource={oddsData}
            pagination={false}
            showHeader={false}
            scroll={{ x: 1000 }}
          />
        </div>
        <div className="event-kpi-table-container-item">
          <h3>Winnings Odds</h3>
          {fixedHeader && (
            <div className="custom-fixed-header">
              <Table
                columns={winningsOddsColumns}
                pagination={false}
                showHeader={true}
                locale={{ emptyText: <span style={{ display: "none" }} /> }}
              />
            </div>
          )}
          <Table
            columns={winningsOddsColumns}
            dataSource={winningsOddsData}
            scroll={{ x: 1000 }}
            showHeader={false}
            pagination={false}
          />
        </div>
      </div>
      <div
        className="event-kpi-row"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <BetTypes />
        <MarketTypes />
      </div>
      <div
        className="event-kpi-row"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <BettingActivity />
        <BetStatuses />
      </div>
    </div>
  );
}

export default EventKpi;
